import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { cn } from '../../lib/utils';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

type ButtonProps = {
    loading?: boolean;
} & React.HTMLAttributes<HTMLButtonElement>;

const ButtonRoot = ({ className, children, loading, ...props }: ButtonProps) => {
    return (
        <button
            className={cn(
                'bg-primary text-white px-5 py-2 rounded disabled:opacity-50 hover:bg-primary-button-hover transition-all ease-in-out',
                className,
            )}
            type="submit"
            {...props}
            disabled={loading}
        >
            {children}
        </button>
    );
};

const IconButton = ({ className, children, loading, ...props }: ButtonProps) => {
    return (
        <button
            className={cn(
                'relative p-3 leading-none bg-gray-200 disabled:opacity-50 rounded-full transition ease-in-out duration-200 hover:bg-gray-300',
                className,
            )}
            {...props}
            disabled={loading}
        >
            {loading && (
                <div className='absolute -left-1 -top-1'>
                    <FontAwesomeIcon icon={faSpinner} className="animate-spin text-primary text-sm" />
                </div>
            )}
            {children}
        </button>
    );
};

export const Button = Object.assign(ButtonRoot, {
    Icon: IconButton,
});
